var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7238 9.59673C18.7238 4.494 14.6123 0.357422 9.54061 0.357422C4.46887 0.357422 0.357422 4.494 0.357422 9.59673C0.357422 14.2083 3.71556 18.0307 8.10573 18.7238V12.2675H5.77407V9.59673H8.10573V7.56119C8.10573 5.24559 9.47676 3.96653 11.5744 3.96653C12.5788 3.96653 13.63 4.14698 13.63 4.14698V6.42072H12.4721C11.3313 6.42072 10.9755 7.13297 10.9755 7.86436V9.59673H13.5224L13.1152 12.2675H10.9755V18.7238C15.3657 18.0307 18.7238 14.2083 18.7238 9.59673Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d97f5b141754bfe5697df69d9c658302.svg";
export { ForwardRef as ReactComponent };